import moment from "moment";
import { KernCAConfig, RoEasyLoading, vRdxUserInfo } from "../../Redux/roStore";
import {
  EasyLoadingVersion_Attributes_GETROW,
  EasyLoadingVersion_EasyLoading_Truckid_dependency,
  EasyLoadingVersion_LH_GETROW,
  EasyLoadingVersion_LoadTripsByDateRange,
  EasyLoadingVersion_NewTrip_Create,
  EasyLoadingVersion_UpdateTripPostingStatus,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  EasyLoadingSubHeader_Set,
  EasyLoadingSubHeader_VocType_Set,
} from "./SliceEasyLoading";

export const WMS_PICKING_DROP_ID_Flag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj?.WMS_PICKING_DROP_ID_LOADING?.Val === "Y";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
export const statusData = [
  {
    id: "Y",
    statusName: "Loaded",
  },
  {
    id: "P",
    statusName: "Partial",
  },
  {
    id: "A",
    statusName: "All",
  },
  {
    id: "N",
    statusName: "pending",
  },
];
export const GetAttributes = async (setVersion, setTruck) => {
  let { VocTyp, VocNo } = RoEasyLoading();

  var vAttributeObj = {
    VocTyp: VocTyp,
    VocNo: VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vAttributeObj);
  const Attributes = await EasyLoadingVersion_Attributes_GETROW(FinalObj);
  if (Attributes?.status === 200) {
    setVersion(Attributes?.data?.ResultSet.LoadVersion);
    setTruck(Attributes?.data?.ResultSet.Truck);
    return Attributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const fNewTrip_Create = async (TruckID = "") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    TruckID: TruckID,
    EnBy: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vObj);
  const Attributes = await EasyLoadingVersion_NewTrip_Create(FinalObj);
  if (Attributes?.status === 200) {
    return Attributes?.data?.ResultSet?.NewTrip || "";
  } else {
    return "";
  }
};
export const fTruckid_dependency = async (TruckID = "") => {
  // const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    TruckID: TruckID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vObj);
  const Attributes = await EasyLoadingVersion_EasyLoading_Truckid_dependency(
    FinalObj
  );
  if (Attributes?.status === 200) {
    return Attributes?.data?.ResultSet?.CurrentTripId || "";
  } else {
  }
};
export const fLoadTripsByDateRange = async (
  StartDate = "",
  EndDate = "",
  setRows
) => {
  var vObj = {
    StartDate: moment(StartDate).format("MM/DD/YYYY"),
    EndDate: moment(EndDate).format("MM/DD/YYYY"),
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vObj);
  const Attributes = await EasyLoadingVersion_LoadTripsByDateRange(FinalObj);
  if (Attributes?.status === 200) {
    let resp =
      Attributes?.data?.ResultSet.length == 0
        ? []
        : Attributes?.data?.ResultSet.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
    setRows(resp);
    return resp;
  } else {
    return [];
  }
};
export const fUpdateTripPostingStatus = async (
  TripID = "",
  handleFetchData
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    TripID: TripID,
    PostBy: vRdxUserInfoObj?.UserID || "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vObj);
  const Attributes = await EasyLoadingVersion_UpdateTripPostingStatus(FinalObj);
  if (Attributes?.status === 200) {
    fAlertToast("SUCCESS", "Trip status updated successfully");
    handleFetchData();
  }
};
export const GetEasyLoadingSubHead = async (
  id,
  dispatch,
  vRdxSubHead,
  fNew
) => {
  let { VocTyp, VocNo } = RoEasyLoading();
  const vRdxUserInfoObj = vRdxUserInfo();
  var vAttributeObj = {
    VocTyp: VocTyp,
    VocNo: VocNo,
    SrNo: id,
    userCode: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vAttributeObj);
  dispatch(EasyLoadingSubHeader_VocType_Set({ vocType: id }));

  const Attributes = await EasyLoadingVersion_LH_GETROW(FinalObj);
  if (Attributes?.status === 200 && Attributes?.data?.ResultSet.length > 0) {
    dispatch(
      EasyLoadingSubHeader_Set({
        ...vRdxSubHead,
        vocType: id,
        TruckId: Attributes?.data?.ResultSet[0].TruckId,
        TruckName: Attributes?.data?.ResultSet[0].TruckName,
        DriverID: Attributes?.data?.ResultSet[0].DriverID,
        DriverName: Attributes?.data?.ResultSet[0].DriverName,
        LoadedCBM: Attributes?.data?.ResultSet[0].LoadedCBM,
        TruckCBM: Attributes?.data?.ResultSet[0].TruckCBM,
        DocStatus: Attributes?.data?.ResultSet[0].DocStatus,
        CurrentTripID: Attributes?.data?.ResultSet[0].CurrentTripID,
      })
    );
    fNew();
    return Attributes?.data?.ResultSet;
  } else if (
    Attributes?.status === 200 &&
    Attributes?.data?.ResultSet.length == 0
  ) {
    dispatch(
      EasyLoadingSubHeader_Set({
        ...vRdxSubHead,
        vocType: id,
        TruckId: "",
        TruckName: "",
        DriverID: "",
        DriverName: "",
        LoadedCBM: 0,
        TruckCBM: 0,
        DocStatus: "ENTER",
      })
    );
    fNew();
  }
};
